import { logger } from '../../../logger';
import { instantiateWasm } from '../../../wasm';
const log = logger('Encryption');

let ready = null;

// eslint-disable-next-line react/display-name
export default function (opts) {
  if (typeof WebAssembly === 'undefined') return null;

  const imp = opts && opts.imports;

  const mod = {
    memory: null,
    exports: null,
    realloc: realloc,
    onload: onload,
    status: 'uninitialized'
  };

  return mod;

  function realloc(size) {
    mod.exports.memory.grow(
      Math.max(0, Math.ceil(Math.abs(size - mod.memory.length) / 65536))
    );
    mod.memory = new Uint8Array(mod.exports.memory.buffer);
  }

  function onload(cb) {
    if (!mod.exports) {
      if (!ready) {
        log.info('Loading SHA512 .wasm file from public');
        mod.status = 'loading';
        ready = fetch('/scripts/wasm/sha512.wasm')
          .then(res => instantiateWasm(res, imp))
          .then(w => {
            mod.exports = w.instance.exports;
            mod.memory = new Uint8Array(w.instance.exports.memory.buffer);
            mod.status = 'ready';
            log.info('SHA512 WASM module loaded', { w });
            return w.instance;
          })
          .then(w => cb(null, w))
          .catch(err => {
            log.info('Error loading sha512 WASM module', err);
            mod.status = 'error';
            cb(new Error(err));
          });
      }
    }
  }
}
